__turbopack_context__.v({
  "arrowButtonLeft": "heroCarousel-module-scss-module__UEWIzW__arrowButtonLeft",
  "arrowButtonRight": "heroCarousel-module-scss-module__UEWIzW__arrowButtonRight",
  "carouselContainer": "heroCarousel-module-scss-module__UEWIzW__carouselContainer",
  "carouselWrapper": "heroCarousel-module-scss-module__UEWIzW__carouselWrapper",
  "dotButton": "heroCarousel-module-scss-module__UEWIzW__dotButton",
  "dotIndicators": "heroCarousel-module-scss-module__UEWIzW__dotIndicators",
  "firstCardGlow": "heroCarousel-module-scss-module__UEWIzW__firstCardGlow",
  "heroCarouselSection": "heroCarousel-module-scss-module__UEWIzW__heroCarouselSection",
  "srOnly": "heroCarousel-module-scss-module__UEWIzW__srOnly",
});
